class RevelPassword {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        document.querySelectorAll('[data-revel-password]').forEach(el => {
            new RevelPasswordItem(el)
        })
    }
}

class RevelPasswordItem {
    constructor(el) {
        this.el = el
        this.el.classList.add('revel-password')

        this.elParent = document.createElement("div")
        this.elParent.classList.add('revel-password')
        this.el.parentNode.insertBefore(this.elParent, this.el)
        this.elParent.appendChild(this.el)

        this.elAction = document.createElement('div')
        this.elAction.classList.add('revel-password-action')
        this.elParent.appendChild(this.elAction)

        this.elAction.addEventListener('click', () => {
            this.togglePasswordAction()
        })
    }
    togglePasswordAction() {
        if (this.el.type === "password") {
            this.el.type = "text";
            this.elParent.classList.add('revel-password--is-show');
        } else {
            this.el.type = "password";
            this.elParent.classList.remove('revel-password--is-show');
        }
    }
}

export default RevelPassword